export const ADMIN_SESSION_STORAGE_KEY = 'jangi.adminSession'

/** caion_user 계정 한 건. 권한은 caion_role.role_level 숫자로 판단한다. */
export type AdminSession = {
  idx: number
  userId: string
  name: string
  email: string
  phone: string
  orgCode: string
  roleCode: string
  roleName: string
  roleLevel: number
  lastLogin: string | null
}

/** 관리자 화면 최소 등급 — ADMIN(90) 이상 */
export const ADMIN_MIN_ROLE_LEVEL = 90

/** 최고관리자. 판매업체 화면 보기 등 일부 기능만 이 등급에서 연다. */
export const SUPER_ADMIN_ROLE_LEVEL = 100

export function saveAdminSession(admin: AdminSession) {
  sessionStorage.setItem(ADMIN_SESSION_STORAGE_KEY, JSON.stringify(admin))
}

export function loadAdminSession(): AdminSession | null {
  const raw = sessionStorage.getItem(ADMIN_SESSION_STORAGE_KEY)
  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw) as AdminSession
    if (!parsed.userId || Number(parsed.roleLevel) < ADMIN_MIN_ROLE_LEVEL) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function clearAdminSession() {
  sessionStorage.removeItem(ADMIN_SESSION_STORAGE_KEY)
}
